import { css } from 'styled-components';
import {
  getTypography, TypographyName, ThemedFunctor, BreakpointQueryName,
} from '@doveit/lego';

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H2)}
  color: ${theme.palettes.brand.primary};
`;

export const feature: ThemedFunctor = ({
  theme,
}) => css`
  margin-top: ${theme.spaceUnits.mobile.BIG};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    padding: ${theme.spaceUnits.desktop.MEDIUM};
    border: 1px solid ${theme.palettes.neutrals.light};
    margin-top: ${theme.spaceUnits.desktop.MEDIUM};
    border-radius: 6px;
  }

  &:first-child {
    margin-top: 0;
  }
`;
